<script setup lang="ts">
const { t, tm, rt } = useI18n()

type Item = { name: string; role: string; text: string }
const items = computed(() =>
  (tm('social.items') as any[]).map((it) => ({
    name: rt(it.name),
    role: rt(it.role),
    text: rt(it.text),
  })) as Item[],
)
</script>

<template>
  <section class="rod-section relative">
    <div class="rod-container">
      <div class="text-center max-w-3xl mx-auto mb-12" data-reveal>
        <div class="rod-eyebrow mb-5">💬 {{ t('social.eyebrow') }}</div>
        <h2 class="rod-h2">{{ t('social.title') }}</h2>
        <!-- These are illustrations: presenting invented people as real users
             would be a fake review under EU consumer law. -->
        <p class="mt-4 text-sm text-[var(--color-text-dim)]">{{ t('social.disclaimer') }}</p>
      </div>

      <div class="grid md:grid-cols-2 gap-5">
        <div v-for="(item, i) in items" :key="i" class="rod-card" data-reveal>
          <p class="text-base leading-relaxed mb-6 text-white/90">{{ item.text }}</p>
          <div class="flex items-center gap-3">
            <div class="w-11 h-11 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 grid place-items-center text-[#0A0A0F] font-display font-bold">
              {{ i + 1 }}
            </div>
            <div>
              <div class="font-semibold">{{ item.name }}</div>
              <div class="text-xs text-[var(--color-text-dim)]">{{ item.role }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
